import { useServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { UpdateMeterModelsArg, UpdateMeterModelsResult } from 'lib/services';
import { useMutation, type UseMutationResult, useQueryClient } from 'react-query';
import { getErrorMessage } from 'utils/getErrorMessage';
import { MUTATION_KEYS, QUERY_KEYS } from 'utils/queryKeys';

export const useUpdateMeterModel = (): UseMutationResult<UpdateMeterModelsResult, unknown, UpdateMeterModelsArg> => {
  const queryClient = useQueryClient();
  const { meterModelsApiClient } = useServices();
  const notify = useAppNotifications();

  return useMutation({
    mutationKey: MUTATION_KEYS.meterModels.updateOne(),
    mutationFn: async (arg: UpdateMeterModelsArg) => await meterModelsApiClient.update(arg),
    onError: error => {
      notify.error({
        message: 'There was an error while updating model',
        description: getErrorMessage(error),
      });
    },
    onSuccess: model => {
      queryClient.invalidateQueries(QUERY_KEYS.meterModels.one(model.id));
      notify.success({
        message: 'Model updated',
      });
    },
  });
};
